"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var mediaHelper_1 = require("../../../../../../../helpers/mediaHelper");
var SinglePostLinkIcon_1 = __importDefault(require("../../../../../../Icons/SinglePostLinkIcon"));
var languageSlice_1 = require("../../../../../../../features/languages/languageSlice");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ProjectCard = function (_a) {
    var _b;
    var item = _a.item, developerLogo = _a.developerLogo, setIsRelatedPostClicked = _a.setIsRelatedPostClicked, isRelatedPostClicked = _a.isRelatedPostClicked;
    var history = react_router_dom_1.useHistory();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var handleNavigateWithSlug = function () {
        var path = item.posts_slugs.find(function (item) { return item.lang === currentLanguage; });
        setIsRelatedPostClicked(!isRelatedPostClicked);
        history.push('/' + path.slug);
    };
    return (react_1.default.createElement("div", { key: item.id, className: classnames_1.default('column', styles_module_scss_1.default.column), onClick: handleNavigateWithSlug },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.column_box },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.column_top },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.building_logo },
                    react_1.default.createElement("div", { style: {
                            backgroundImage: "url(\"" + (developerLogo !== null && developerLogo !== void 0 ? developerLogo : '/images/no-image.svg') + "\")",
                        } })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.post_image, style: {
                        backgroundImage: ((_b = item.related_parent_entity
                            .developer_post_primary_image) === null || _b === void 0 ? void 0 : _b.path) &&
                            "url(\"" + mediaHelper_1.resolveThumbByExtension(item.related_parent_entity
                                .developer_post_primary_image.path) + "\")",
                    } })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", null, item.related_parent_entity.building_name.value),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.href_link },
                    react_1.default.createElement(SinglePostLinkIcon_1.default, null))))));
};
exports.default = ProjectCard;
